module.exports = __webpack_public_path__ + "img/president-polk.4aa66cc9.png";